import { render, staticRenderFns } from "./AuthLayoutQuest.vue?vue&type=template&id=55306a24&"
import script from "./AuthLayoutQuest.vue?vue&type=script&lang=js&"
export * from "./AuthLayoutQuest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports